import { render, staticRenderFns } from "./AddTripPopup.vue?vue&type=template&id=4b45ab18&scoped=true"
import script from "./AddTripPopup.vue?vue&type=script&lang=js"
export * from "./AddTripPopup.vue?vue&type=script&lang=js"
import style0 from "./AddTripPopup.vue?vue&type=style&index=0&id=4b45ab18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b45ab18",
  null
  
)

export default component.exports